"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LabelToInput;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _style = require("./style");

var _Input = _interopRequireDefault(require("../Input"));

var _jsxRuntime = require("react/jsx-runtime");

function LabelToInput(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      defaultValue = _useState4[0],
      setDefaultValue = _useState4[1];

  (0, _react.useEffect)(function () {
    setDefaultValue(props.defaultValue === "" ? "-" : props.defaultValue);
  }, [props.defaultValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MainContainer, {
    width: props.width,
    error: !isActive && props.error,
    children: !isActive ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      onClick: function onClick() {
        return setIsActive(true);
      },
      children: defaultValue
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
      onBlur: function onBlur() {
        props.onBlur && props.onBlur();
        setIsActive(false);
      }
    }))
  });
}